import career1 from "../assets/Careers/career1 Public Notice for Re-Scheduling of Written Examination for the posts of Upper Division Clerk (BPS-11).jpg";
import career2 from "../assets/Careers/career2 Public Notice for Recruitment on ASPOS AS (MST) in Direct Quota Under The Pakistan Post Office Department.pdf";
import career3 from "../assets/Careers/career3 Corrigendum of Advertisement for Appointment on Vacant Vacancies of BPS 1-15 of the Pakistan Post % ADDG (Estt) Directorate General Pakistan Post Islamabad.pdf";

export const CareersData = [
  {
    id: 1,
    title:
      " Public Notice for Re-Scheduling of Written Examination for the posts of Upper Division Clerk (BPS-11) and Assistant (BPS-15) Under The Pakistan Post Office Department ",
    url: career1,
  },
  {
    id: 2,
    title:
      " Public Notice for Recruitment on ASPOS/ AS (MST) in Direct Quota Under The Pakistan Post Office Department ",
    url: career2,
  },
  {
    id: 3,
    title:
      " Corrigendum of Advertisement for Appointment on Vacant Vacancies of BPS 1-15 of the Pakistan Post % ADDG (Estt) Directorate General Pakistan Post Islamabad ",
    url: career3,
  },
];
